import {axiosRequest} from "../api";
import {API_PATH} from "../../constants";

export const ProgramService = {
  getProgramsList(params){ return axiosRequest('GET', API_PATH.PROGRAM.LIST(params)) },
  getProgram(data){ return axiosRequest('POST', API_PATH.PROGRAM.INFO, data) },
  addProgram(data){ return axiosRequest('POST', API_PATH.PROGRAM.ADD, data) },
  deleteProgram(data){ return axiosRequest('POST', API_PATH.PROGRAM.DELETE, data) },
}